export function getPrintInfo(job) {
    let dateText = " ";
    let date = " ";
    let popup = "No info available";

    if (job.printingStatus === "INCOMPLETE") {
        dateText = "Printing job started: ";
        date = job.dates.enquiryReceived;
        popup = "New";
    } else if (job.printingStatus === "COMPLETE") {
        dateText = "Printing job completed: ";
        date = job.dates.enquiryApproved;
        popup = "Printing completed";
    }

    return [dateText, date, popup];

}